import { NodeTextPosition } from '../domop';

export class RangeInternal {
    public static fromRange(range: Range) {
        return new RangeInternal(range.startContainer, range.startOffset, range.endContainer, range.endOffset);
    }
    public static fromTextPosition(cursor: NodeTextPosition) {
        return new RangeInternal(cursor.container, cursor.offset, cursor.container, cursor.offset);
    }
    public static fromTextPositions(start: NodeTextPosition, end: NodeTextPosition) {
        return new RangeInternal(start.container, start.offset, end.container, end.offset);
    }

    public constructor(
        public readonly startContainer: Node,
        public readonly startOffset: number,
        public readonly endContainer: Node,
        public readonly endOffset: number,
    ) { }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/RangeInternal.tsx